import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PolicyService} from '../../policy/services/policy.service';
import {API_PATH} from '../../shared/constants';
import {ClaimData, ClaimsLandingDetails, FlowQuestion} from '../../shared/models/claim.model';
import {ClaimsDataStore} from '../state/state/claims-data.store';
import {ClaimsFlowQuestionsDataQuery} from '../state/state/claims-questions.query';
import {ClaimsQuestionStore} from '../state/state/claims-questions.store';
import {ClaimQuery} from '../state/state/claims-session.query';
import {ClaimsStore} from '../state/state/claim.store';
import {UserStore} from '../../authentication/state/user.store';
import {ItemStore} from '../state/state/item.store';
import {ItemQuery} from '../state/state/item.query';
import {PolicyQuery} from '../../policy/state/policy.query';
import {ClaimStore} from '../state/state/claims-session.store';
import {GlobalQuestionService} from '../../shared/services/global-question.service';

const headers = new HttpHeaders()
  .set('content-type', 'application/json')
  .set('Access-Control-Allow-Origin', '*')
  .set('Accept', 'application/json');

@Injectable({
  providedIn: 'root'
})
export class ClaimsService {

  constructor(
    private httpClient: HttpClient,
    private claimsDataStore: ClaimsDataStore,
    private globalQuestionService: GlobalQuestionService,
    private claimStore: ClaimStore,
    private claimsDataQuery: ClaimsFlowQuestionsDataQuery,
    private claimsFlowQuestionStore: ClaimsQuestionStore,
    private claimQuery: ClaimQuery,
    private policyQuery: PolicyQuery,
    private policyService: PolicyService,
    private userStore: UserStore,
    private itemStore: ItemStore,
    private itemQuery: ItemQuery,
    private claimsStore: ClaimsStore) {
  }

  submitResponse(answer: any, answer_id: number, class_id: number, item_id: string, question: any): void {
    if (question.angular_component === 'app-claim-multiselect-items') {
      const selectedItems = JSON.parse(answer);
      if (selectedItems !== undefined) {
        this.claimStore.update({current_collation_id: selectedItems[0].calc_collation_id});
      }
    }
    const claimDetails = this.claimQuery.getValue();
    this.saveAnswer(answer, answer_id, class_id, item_id, claimDetails, question);
  }

  updateClaimStore(claimDetails: any): void {
    this.claimStore.update(claimDetails);
  }

  getFeedMenuGroupQuestions(): Observable<any> {
    return this.claimsDataQuery.feedMenuGroups();
  }

  getClaims(personId: number, sessionId: string = ''): Observable<ClaimsLandingDetails[]> {
    this.claimStore.reset();
    this.claimsStore.reset();
    const url = sessionId
      ? `${API_PATH.CLAIMS}/${personId}?session_id=${sessionId}`
      : `${API_PATH.CLAIMS}/${personId}`;
    return this.httpClient.get<ClaimsLandingDetails[]>(url, {headers});
  }

  editClaim(claim_id: number, current_session_id: string){
    const parameters = new Map<string, string>();
    parameters.set('claim_id', claim_id.toString());
    parameters.set('current_session_id', current_session_id);
    return this.globalQuestionService.runCommandNew("editClaim", parameters);
  }

  getItems(reset: boolean): void {
    const activeId = this.itemQuery.getActiveId();
    // if(reset === true){
    // this.itemStore.reset();
    // }
    const selectedPolicy: any = this.policyQuery.getActive();
    const components = [
      'app-claim-multiselect-items',
      'app-claim-multiselect-benefits',
      'app-claim-multiselect-grouped'
    ];
    this.getQuestionsByComponents(components)
      .subscribe((questions: FlowQuestion[]) => {
        if (!questions) {
          return;
        }
        const items: any[] = [];
        questions?.forEach((question: FlowQuestion) => {
          if (question.answer !== '' && question.answer !== undefined) {
            const saved_items = JSON.parse(question.answer);
            saved_items?.forEach((i: any) => {
              const currentIndex = selectedPolicy?.collation?.findIndex((col: any) => col.calc_collation_id === i.calc_collation_id);
              if (currentIndex !== -1) {
                const currentItem = selectedPolicy?.collation[currentIndex];
                if (currentItem !== undefined) {
                  const item = {
                    description_1: currentItem.description_1,
                    session_id: currentItem.session_id,
                    session_item_id: currentItem.session_item_id,
                    description_2: currentItem.description_2,
                    id: currentItem.calc_collation_id,
                    class_id: i.class_id,
                    state: 'inactive'
                  };
                  if (!this.itemQuery.hasEntity(currentItem.calc_collation_id)) {
                    items.push(item);
                  }
                }
              }

              const currentVapsIndex = selectedPolicy?.included?.findIndex((ben: any) => ben.calc_collation_vaps_id === i.calc_collation_vaps_id);
              if (currentVapsIndex !== -1) {
                const currentVapsItem = selectedPolicy.included[currentVapsIndex];
                if (currentVapsItem !== undefined) {
                  const vapsItem = {
                    item_type: 'benefit',
                    session_id: currentVapsItem.session_id,
                    session_item_id: currentVapsItem.session_item_id,
                    detail: currentVapsItem.detail,
                    id: currentVapsItem.calc_collation_vaps_id,
                    class_id: i.class_id,
                    state: 'inactive'
                  };
                  if (!this.itemQuery.hasEntity(currentVapsItem.calc_collation_vaps_id)) {
                    items.push(vapsItem);
                  }
                }
              }
            });
          }
        });

        if (activeId !== undefined && activeId != null) {
          this.itemStore.set(items, activeId);
        } else {
          this.itemStore.set(items);
        }
      });

  }

  setActiveItem(activeId: any): void {
    this.itemStore.setActive(activeId);
  }

  saveAnswer(answer: any, answer_id: number, class_id: number, item_id: string, claimDetails: any, question: any): void {
    this.policyService.saveAnswer(claimDetails.session_id, question.cent_aq_question_id, class_id, item_id, answer, answer_id)
      .subscribe((result: any) => {
          if (question.call_proc !== null && question.call_proc !== '') {
            return this.runCommand(this.replaceCallProcParemeters(question.call_proc, '0', claimDetails.session_id, this.userStore.getValue()?.person_id, question.page))
              .subscribe((val: any) => {
                if (!val) {
                  return undefined;
                }
                if (val) {
                  let retrieved = false;
                  if (val[0]?.next !== undefined) {
                    if (val[0].calc_collation_id !== undefined && val[0].calc_collation_id !== '' && val[0].calc_collation_id != null) {
                      // this.itemStore.setActive(val[0].calc_collation_id);

                      this.setActiveItem(val[0].calc_collation_id);
                    }
                    return this.getQuestion(val[0].next)
                      .subscribe((q: any) => {
                        if (!q) {
                          return;
                        }
                        if (q[0] !== undefined) {
                          if (retrieved === true) {
                            return;
                          } else {
                            const question_id = q[0].cent_aq_question_id;

                            this.flowQuestions(3, 3, claimDetails.session_id, 0, 0)
                              .subscribe((v: any) => {
                                if (!v) {
                                  return;
                                }
                                retrieved = true;
                                this.claimsFlowQuestionStore.set(v);
                                this.setActive(question_id);
                                this.setActiveItem(1707924);
                              });
                          }
                        }

                      });
                  }
                }

                return this.getNext(question, claimDetails, item_id);
              });
          } else {
            return this.getNext(question, claimDetails, item_id);
          }
        },
        err => {
          console.log(err);
        });
    this.updateClaimStore(claimDetails);
  }

  getNext(question: any, claimDetails: any, item_id: any): any {
    let retrieved = false;
    if (!question.conditions?.length) {
      return this.getQuestion(question.next)
        .subscribe((q: any) => {
          if (!q) {
            return;
          }
          if (q[0] !== undefined) {
            if (retrieved === true) {
              return;
            } else {
              const question_id = q[0].cent_aq_question_id;

              this.flowQuestions(3, 3, claimDetails.session_id, 0, 0)
                .subscribe((val: any) => {
                  if (!val) {
                    return;
                  }
                  retrieved = true;
                  this.claimsFlowQuestionStore.set(val);
                  this.setActive(question_id);
                });
            }

          }

        });
    } else {
      return this.getNextQuestion(question, claimDetails.session_id, item_id, 0)
        .subscribe((val: any) => {
          if (!val) {
            return;
          }
          if (val[0] !== undefined) {
            const next_question_id = val[0].next;
            this.flowQuestions(3, 3, claimDetails.session_id, 0, 0)
              .subscribe((v: any) => {
                this.claimsFlowQuestionStore.set(v);
                this.setActive(next_question_id);
              });
          }
        });
    }
  }


  replaceCallProcParemeters(call_proc: string, item_id: string, session_id: string, person_id: any, page: any): any {
    const selectedPolicy: any = this.policyQuery.getActive();
    let policy_session_id = '';
    if (selectedPolicy !== undefined) {
      policy_session_id = selectedPolicy.session_id;
    }
    return call_proc.replace(/{session_id}/g, session_id).replace(/{person_id}/g, person_id).replace(/{item_id}/g, item_id).replace(/{policy_session_id}/g, policy_session_id).replace(/{page}/g, page);
  }

  runCommand(command: string): Observable<any> {
    return this.httpClient.get(`${API_PATH.RUN_COMMAND}/${encodeURIComponent(command)}`);
  }

  getPreviousQuestion(question: FlowQuestion): void {
    this.claimsDataQuery.selectAll({
      limitTo: 1,
      filterBy: [
        entity => entity.page === question.page - 1 && entity.answer !== '' && entity.answer !== undefined
      ]
    })
      .subscribe(val => {
        if (!val) {
          return;
        }
        if (val[0]?.cent_aq_question_id !== undefined) {
          this.setActive(val[0]?.cent_aq_question_id);
        }
      });
  }


  getNextQuestion(currentQuestion: FlowQuestion, session_id: any, item_id: any, index: any): Observable<any> {
    return this.httpClient.get(`${API_PATH.GET_NEXT_QUESTION}/${session_id}/${item_id}/${currentQuestion.cent_aq_question_id}/${index}`);
  }


  setActive(id: any): void {
    this.claimsFlowQuestionStore.setActive(id);
  }

  createUpdateClaim(policySessionId: any, sessionId: any, claimTypeId: any, claimName: any, claim_id, claim_status: any, person_id: number): Observable<any> {
    const requestBody = {
      Id: claim_id,
      ClaimName: claimName,
      ClaimTypeId: claimTypeId,
      SessionId: sessionId,
      PolicySessionId: policySessionId,
      ClaimStatus: claim_status,
      PersonId: person_id
    };
    return this.httpClient.post(`${API_PATH.CREATE_UPDATE_CLAIM}`, requestBody);
  }

  createClaim(session_id: any, person_id: number): Observable<any> {
    return this.httpClient.get(`${API_PATH.CREATE_CLAIM}/${session_id}/${person_id}`, {headers, responseType: 'json'});
  }

  getActiveQuestion(): any {
    return this.claimsFlowQuestionStore.getValue();
  }

  updateActive(question: FlowQuestion): void {
    this.claimsFlowQuestionStore.updateActive(question);
  }

  getQuestion(currentQuestionId: any): Observable<FlowQuestion[]> {
    return this.claimsDataQuery.getById(currentQuestionId);
  }

  getQuestionsByParent(parent_id: any): Observable<any> {
    return this.claimsDataQuery.getByParentControl(parent_id);
  }

  getQuestionByComponent(component: any): Observable<any> {
    return this.claimsDataQuery.getByComponent(component);
  }

  getQuestionsByComponents(components: string[]): Observable<any> {
    return this.claimsDataQuery.getByComponents(components);
  }

  getAllQuestions(): Observable<FlowQuestion[]> {
    return this.claimsDataQuery.getClaimFlowQuestions();
  }

  getFlowQuestions(flowId: any, categoryId: any, sessionId: any, groupId: any, itemId: any): void {
    this.claimsFlowQuestionStore.reset();
    this.httpClient.get(`${API_PATH.GET_FLOW_QUESTIONS}/${flowId}/${categoryId}/${sessionId}`,
      {headers, responseType: 'json'})?.subscribe((flowQuestions: any) => {
      this.claimsFlowQuestionStore.set(flowQuestions);
    });
  }

  flowQuestions(flowId: any, categoryId: any, sessionId: any, groupId: any, itemId: any): Observable<any> {
    return this.httpClient.get(`${API_PATH.GET_FLOW_QUESTIONS}/${flowId}/${categoryId}/${sessionId}`,
      {headers, responseType: 'json'});
  }

  getCategories(): Observable<any> {
    return this.httpClient.get(`${API_PATH.GET_CATEGORIES}`, {headers});
  }

  getClasses(categoryId: number, groupId: number): Observable<any> {
    return this.httpClient.get(`${API_PATH.GET_CLASSES}/${categoryId}/${groupId}`, {headers, responseType: 'json'});
  }

  getClaimsData(personId: any, productId: any): void {
    this.claimsDataStore.reset();
    this.httpClient.get(`${API_PATH.GET_CLAIMSDATA}/${personId}/${productId}`,
      {headers, responseType: 'json'})?.subscribe((claimsData: any) => {
      const claimModel: ClaimData = new ClaimData();
      const claimsModels: any[] = [];
      claimsData.forEach((element: any) => {
        const index = element[0].index;
        if (index === 1) {
          element.forEach((person: any) => {
            claimModel.persons.push(person);
          });
        }
        if (index === 2) {
          element.forEach((policy: any) => {
            claimModel.policies.push(policy);
          });
        }
        if (index === 3) {
          element.forEach((category: any) => {
            claimModel.categories.push(category);
          });
        }
        if (index === 4) {
          element.forEach((classObject: any) => {
            claimModel.classes.push(classObject);
          });
        }
        if (index === 5) {
          element.forEach((eventType: any) => {
            claimModel.eventTypes.push(eventType);
          });
        }
        if (index === 6) {
          element.forEach((vehicle: any) => {
            claimModel.vehicles.push(vehicle);
          });
        }
        if (index === 7) {
          element.forEach((vehicleBenefit: any) => {
            claimModel.vehicleBenefits.push(vehicleBenefit);
          });
        }
        claimsModels.push(claimModel);
      });
      this.claimsDataStore.set(claimsModels);
    });

  }

}
